/**
* [Flags]
*/
export var DataDescriptionType;
(function (DataDescriptionType) {
    DataDescriptionType[DataDescriptionType["Read"] = 1] = "Read";
    DataDescriptionType[DataDescriptionType["Write"] = 2] = "Write";
})(DataDescriptionType || (DataDescriptionType = {}));
;
